import { render, staticRenderFns } from "./GLVATAccounts.vue?vue&type=template&id=a163b376&scoped=true&"
import script from "./GLVATAccounts.vue?vue&type=script&lang=js&"
export * from "./GLVATAccounts.vue?vue&type=script&lang=js&"
import style0 from "./GLVATAccounts.vue?vue&type=style&index=0&id=a163b376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a163b376",
  null
  
)

export default component.exports